export default __webpack_public_path__ + "static/media/vegan.52cbfe9e.jpg";